import { getMultiselectValue } from "@client/lib/settings";
import { eventsItemsSelector, getSettingValueSelector, TargetSelector } from "@client/selectors";
import { type OptionItem } from "@client/types";
import { createSelector } from "reselect";
import { localStateCategoriesSelector } from "../../selectors";

export const makeCategoryOptionsSelector = () => {
  const categorySettingsSelector = getSettingValueSelector(
    TargetSelector.Entity,
    "category",
    undefined,
    getMultiselectValue
  );

  return createSelector(
    [localStateCategoriesSelector, categorySettingsSelector],
    (lsCategories, categories): OptionItem<string>[] => {
      if (!categories) return [];

      const items = lsCategories.filter((x) => categories.includes(x.id));

      return items.map((x) => ({ label: x.name, value: x.id }));
    }
  );
};

export const eventOptionsSelector = createSelector([eventsItemsSelector], (items): OptionItem<string>[] =>
  items.map((x) => ({ label: x.name, value: x.id }))
);
